import * as React from 'react';

interface LoadingIndicatorProps {
  label?: string;
  size?: 'small' | 'large';
  textPosition?: 'bottom' | 'right';
  color?: 'normal' | 'inverse';
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props) => {
  let className = 'vmo-loader';
  className += ` vmo-textpos-${props.textPosition || 'bottom'}`;
  className += ` vmo-color-${props.color || 'normal'}`;
  className += ` vmo-size-${props.size || 'large'}`;

  let label: React.JSX.Element | undefined;
  if (props.label) {
    label = <span className="vmo-label">{props.label}</span>;
  }

  return (
    <div className={className}>
      <div>
        <div className="lds-rolling">
          <div></div>
        </div>
        <span>{label}</span>
      </div>
    </div>
  );
};

export default LoadingIndicator;
